import { apiGet, apiPatch } from './client';
import type { SwapKosherFund, SwapKosherFundBatchRequest } from '../types/SwapKosherFund';

// Tenant-scoped (X-Tenant-Id applied by the client).
export function getSwapKosherFunds(): Promise<SwapKosherFund[]> {
  return apiGet<SwapKosherFund[]>('/api/swap-kosher-funds');
}

export function saveBatchSwapKosherFunds(added: SwapKosherFund[], modified: SwapKosherFund[], deletedIds: number[]): Promise<SwapKosherFund[]> {
  return apiPatch<SwapKosherFundBatchRequest, SwapKosherFund[]>('/api/swap-kosher-funds/batch', { added, modified, deleted: deletedIds });
}
